<template>
  <!-- İlk gezinme bitene kadar (vue-router 4'te asenkron) layout yoktur; Vue 2'deki gibi boş kalır. -->
  <component v-if="$router.currentRoute.meta.layout" :is="$router.currentRoute.meta.layout">
    <router-view :key="$router.currentRoute.path" />
  </component>
  <!-- Programatik modalların (`$modal.show`, utils/modalService) host'u: sayfa düzenlerinin dışında,
       document.body'nin sonunda (ekran geçişinin transform'u ve #content-page stacking context'i etkilemez). -->
  <Teleport to="body">
    <ModalHost />
  </Teleport>
</template>
<script>
  import { installRipple } from './utils/ripple'
  import { interceptorsSetup } from './helpers/axiosInterceptors'
  import authService from './services/auth'
  import ModalHost from './components/shared/modal/ModalHost.vue'

  export default {
    name: 'App',
    components: { ModalHost },
    // Eski kök örneğin (main.js `new Vue`) created'ı: createApp'te kök seçenekleri yok.
    created() {
      interceptorsSetup()
      this.$store.dispatch('Auth/setCurrentUser')
      this.$store.dispatch('Auth/setCurrentBranch', { branchId: null, branchName: null, timezone: null })

      authService.getTenantInfo()

      this.$bus.$on('UiLanguageChanged', (language) => {
        this.$i18n.locale = language;
        this.$store.dispatch('Auth/setCurrentLanguage', language)
      });
    },
    mounted() {
      installRipple()
    }
  }
</script>
<style lang="scss">
  @import "assets/scss/style.scss";
</style>
